<template>
  <div class="module-wrapper">
    <lazy-component @show.once="render">
      <ModuleTitle title="基金规模" v-if="!dataEmpty" class="bottom-line"/>
      <ModuleTitle title="基金规模" desc="暂无基金规模信息" v-if="dataEmpty"/>
      <FundChartScale ref="FundChartScale" v-if="!dataEmpty" :showEmpty="showEmpty"/>
      <ModuleButton :click="clickMore" value="更多规模信息" v-if="!dataEmpty"/>
      <separatorView />
    </lazy-component>
  </div>
</template>

<script>
import ModuleButton from '@/components/ModuleButton.vue';
import ModuleTitle from '@/components/ModuleTitle.vue';
import separatorView from '@/components/SeparatorView.vue';
import FundChartScale from '@/components/FundChart/scale.vue';
import StoreManger from '@/utils/FundHQJHManger';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'FundSize',
  components: {
    separatorView,
    ModuleTitle,
    ModuleButton,
    FundChartScale,
  },
  data() {
    return {
      nativeData: {},
      fundCode: '',
      fundType: '',
      dataEmpty: false,
    };
  },
  created() {
    // this.fundCode = this.$store.state.native.fund.fundCode;
    // this.fundType = this.$store.state.native.fund.fundType;
    // this.handleDefault();
  },
  mounted() {
    // this.render();
  },
  methods: {
    showEmpty() {
      this.dataEmpty = true;
    },
    render() {
      this.nativeData = this.$store.state.native.fund;
      this.fundCode = this.nativeData.fundCode;
      this.fundType = this.nativeData.fundType;
      const refs = this.$refs;
      refs.FundChartScale.render();
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const code = StoreManger.getFundJJXQCODE(baseInfo);
      detailPushPage({
        appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
        url: '/pages/FundScale',
        params: {
          fundCode: code,
          fundName: name,
        },
      });
      this.reportMonitor({
        eventName: 'pz.xx.gmfe',
      });
    },
  },
};
</script>

<style scoped lang="less">
  .bottom-line {
    // border-bottom: 2px solid #EEEEEE;
  }
  .module-wrapper {
    background-color: #ffffff;
  }
</style>
